import { render, staticRenderFns } from "./CreateGlassType.vue?vue&type=template&id=65a39a1e&"
import script from "./CreateGlassType.vue?vue&type=script&lang=js&"
export * from "./CreateGlassType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports